import { default as React } from 'react';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import { connect } from 'react-redux';
import { safeRender } from '../../../../shared';
import { getAppState } from '../../../../appstate';
import { getLeftPaneStyles } from '../../../utils/leftNavStyle';
import type BrowserWidthBucket from 'owa-layout/lib/store/schema/BrowserWidthBucket';

const widthWithPaneHidden = 48;
const leftNavigationPaneModule = new LazyModule(
    () => import(/* webpackChunkName: "LeftNavigationPane" */ './leftNavigationPane')
);
const LeftNavigationPaneAsync = createLazyComponent(leftNavigationPaneModule, m => m.default);
type Props = { leftNavWidth: number; browserWidthBucket: BrowserWidthBucket };
const leftNavigationPane = (props: Props) => (
    <div className={getLeftPaneStyles(props.leftNavWidth, props.browserWidthBucket)}>
        <LeftNavigationPaneAsync />
    </div>
);

const mapStateToProps = (rootState: {}): Props => {
    const appState = getAppState(rootState);
    return {
        leftNavWidth: appState.view.layoutState.isLeftNavVisible
            ? appState.view.layoutState.leftPaneWidth
            : widthWithPaneHidden,
        browserWidthBucket: appState.view.layoutState.browserWidthBucket,
    };
};

export default connect(mapStateToProps)(safeRender(leftNavigationPane, 'LeftNavigationPaneAsync'));
